import api from './api';

export const getSpeseTecniche = async (cantiereId) => {
  const res = await api.get(`/budget/spese-tecniche/${cantiereId}`);
  return res.data;
};

export const saveSpeseTecniche = async (cantiereId, dati) => {
  const res = await api.post(`/budget/spese-tecniche/${cantiereId}`, dati);
  return res.data;
};